import { BgImage } from '@/components/widgets/blog/BlogImage.styles'

type BlogImageProps = {
  image: string
}

const BlogImage: React.FC<BlogImageProps> = ({ image }) => {
  return <BgImage imageUrl={image} />
}

export default BlogImage
